// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__344bc","rootSmall":"AddTileButton_rootSmall__2xmOW"};